import type { FC } from 'react'
import { Avatar } from '@mui/material'
import { BLUE, NAVY } from '~/shared/lib/theme'

const AVATAR_COLORS = [BLUE[600], NAVY[400], BLUE[800], NAVY[300], BLUE[500]]

const avatarColor = (id: number) => AVATAR_COLORS[id % AVATAR_COLORS.length]

const initials = (first?: string | null, last?: string | null) =>
  `${first?.[0] ?? ''}${last?.[0] ?? ''}`.toUpperCase() || '—'

export const MemberAvatar: FC<{
  id: number
  firstName?: string | null
  lastName?: string | null
  size?: number
}> = ({ id, firstName, lastName, size = 28 }) => (
  <Avatar sx={{ width: size, height: size, fontSize: size * 0.43, bgcolor: avatarColor(id) }}>
    {initials(firstName, lastName)}
  </Avatar>
)
